import { useStyletron } from 'baseui';

type Props = {
  show: boolean;
  clicked: () => void;
};

const Backdrop = ({ show, clicked }: Props) => {
  const [css] = useStyletron();

  return show ? (
    <div
      className={css({
        width: '100%',
        height: '100%',
        position: 'fixed',
        zIndex: 100,
        left: 0,
        top: 0,
        background: 'rgba(0, 0, 0, 0.5)',
      })}
      onClick={clicked}
    ></div>
  ) : null;
};

export default Backdrop;
